const holidaysReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default holidaysReducer;